function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12 6.5h-.833V4.833a4.167 4.167 0 00-8.334 0V6.5H2A1.667 1.667 0 00.333 8.166V16.5A1.666 1.666 0 002 18.166h10a1.666 1.666 0 001.667-1.666V8.166A1.667 1.667 0 0012 6.5zm-4.167 5.608v2.725a.833.833 0 01-1.666 0v-2.725a1.667 1.667 0 111.666 0zM9.583 6.5H4.417V4.833a2.583 2.583 0 015.166 0V6.5z",
  fill: "currentColor"
});

function SvgLockKeyholeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgLockKeyholeIcon;